export default {
  VerifyModal: {
    title: "Есептік жазбаны растаңыз",
    send: "Тексеруге жіберу",
    step1: {
      reason:
        "Қызмет тек медициналық мамандарға арналған, сондықтан кейбір функцияларға қол жеткізу тек расталған пайдаланушылар үшін шектелген. Бұл мыналарды қамтамасыз етеді:",
      reasons: {
        1: "Пациенттер мен бөгде адамдардың қол жеткізуін болдырмау",
        2: "Білім мен тәжірибе алмасуға арналған кәсіби қауымдастықты қамтамасыз ету",
        3: "Медициналық этика мен деректермен жұмыс істеу стандарттарын сақтау",
      },
      end: "Біз сіздің қауіпсіздігіңіз бен құпиялылығыңызды бағалаймыз. Барлық ақпарат тек сіздің мәртебеңізді растау үшін пайдаланылады және процесс аяқталғаннан кейін жойылады.",
      status: "Мәртебе",
      statuses: {
        doctor: "Дәрігер",
        student: "Студент",
        ordinator: "Ординатор",
      },
    },
    step2: {
      agenda:
        "Барлық берілген деректер қорғалған және тек сіздің мәртебеңізді тексеру үшін пайдаланылады.",
      chooseVerifyWay: "Растау әдісін таңдаңыз",
      ways: {
        1: "Диплом, сертификат немесе куәлік",
        2: "Медициналық агрегатордағы расталған парақшаңызға сілтеме (Продокторов, DocDoc және т.б.)",
        3: "Клиника сайтындағы парақшаңызға сілтеме",
        4: "Медициналық білім дипломын жүктеңіз",
        5: "Медициналық ЖОО студенттік билетін жүктеңіз",
      },
      selectFile: "Файлды таңдаңыз",
      sendToCheck: "Тексеруге жіберу",
      pasteLink: "Сілтемені енгізіңіз",
      notAllowedFile: "Тек PDF және суреттерге рұқсат етіледі.",
      noMoreFiles: "Файлдардың максималды саны - ",
    },
    step3: {
      title: "Құжат тексеруге жіберілді",
      text1_1:
        "Біз сіздің деректеріңізді тексереміз, содан кейін сіздің поштаңызға хабарлама келеді ",
      text1_2: "",
      text2: "Тексеру бір жұмыс күнін алады.",
    },
  },
};
